import clsx from "clsx";
import * as userSelectors from "../../../../selectors/user";
import { getUserLastLoginAtText } from "../../../../selectors/user";
import Image from "react-bootstrap/Image";

function ProfileInfoComponent({ profileData }) {
  const name = userSelectors.getUserName(profileData);
  const identityValue = userSelectors.getUserIdentityValue(profileData);
  const lastLoginAt = userSelectors.getUserLastLoginAtText(profileData);
  const lastPasswordChangedAtText =
    userSelectors.getUserLastPasswordChangedAtText(profileData);

  return (
    <div className={clsx("profile-left-card mt-3")} style={{ background: "white", boxShadow: "0 0.2rem 0.2rem rgba(0, 0, 0, 0.05)" }}>
      <div className={clsx("profile-left-card-image-container")}>
        <Image src="/img/ta-securities-logo.png"></Image>
      </div>
      <div className={clsx("profile-left-card-content")}>
        <div className={clsx("profile-name")}>{name}</div>
        <div className={clsx("last-login-text")}>Last Login: {lastLoginAt}</div>
      </div>
    </div>
  );
}

export default ProfileInfoComponent;